import { h } from 'preact'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import InfoIcon from '../../../assets/icons/InfoTooltip.svg'
import styles from './InfoMessage.module.scss'

const InfoMessage = ({ message, className, ...props }) => {
  const infoMessageClasses = classNames(styles.infoMessage, className)

  return (
    <div className={infoMessageClasses} {...props}>
      <img className={styles.infoMessage__icon} src={InfoIcon} alt="info" />
      <span className={styles.infoMessage__text}>{message}</span>
    </div>
  )
}

InfoMessage.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
}

export default InfoMessage
